import { create } from '@bufbuild/protobuf';

import { wsAppRequestManager } from '../WsAppApi';
import {
  GetDevicesRequestSchema,
  SetDeviceStatusRequest,
  SetDeviceStatusRequestSchema,
  TerminateDevicesRequest,
} from '../types/device/device_request_pb';
import {
  GetDevicesResponse,
  SetDeviceStatusResponse,
  TerminateDevicesResponse,
  TerminateDevicesSuccessSchema,
} from '../types/device/device_response_pb';
import {
  GetUsersByEmailsRequest,
  GetUsersByEmailsRequestSchema,
  UpdateProfileRequest,
  UpdateProfileRequestSchema,
  UsersByIdsRequest,
  UsersByIdsRequestSchema,
} from '../types/user/user_requests_pb';
import {
  GetUsersByEmailsResponse,
  UpdateProfileResponse,
  UsersByIdsResponse,
} from '../types/user/user_responses_pb';
import { WsRequest } from './request.types';

export function getUsersByIdsRequest(
  data: WsRequest<UsersByIdsRequest>
): Promise<UsersByIdsResponse> {
  return wsAppRequestManager.request<UsersByIdsResponse>({
    case: 'usersByIds',
    value: create(UsersByIdsRequestSchema, data),
  });
}

export function updateProfileRequest(
  data: WsRequest<UpdateProfileRequest>
): Promise<UpdateProfileResponse> {
  return wsAppRequestManager.request<UpdateProfileResponse>({
    case: 'updateProfile',
    value: create(UpdateProfileRequestSchema, data),
  });
}

export function getDevicesInfoRequest(): Promise<GetDevicesResponse> {
  return wsAppRequestManager.request<GetDevicesResponse>({
    case: 'getDevices',
    value: create(GetDevicesRequestSchema, {}),
  });
}

export function terminateDevicesRequest(
  data: WsRequest<TerminateDevicesRequest>
): Promise<TerminateDevicesResponse> {
  return wsAppRequestManager.request<TerminateDevicesResponse>({
    case: 'terminateDevices',
    value: create(TerminateDevicesSuccessSchema, data),
  });
}

export function getUsersByEmailsRequest(
  data: WsRequest<GetUsersByEmailsRequest>
): Promise<GetUsersByEmailsResponse> {
  return wsAppRequestManager.request<GetUsersByEmailsResponse>({
    case: 'getUsersByEmails',
    value: create(GetUsersByEmailsRequestSchema, data),
  });
}

export function setDeviceStatusRequest(
  data: WsRequest<SetDeviceStatusRequest>
): Promise<SetDeviceStatusResponse> {
  return wsAppRequestManager.request<SetDeviceStatusResponse>({
    case: 'setDeviceStatus',
    value: create(SetDeviceStatusRequestSchema, data),
  });
}
